module.exports = __webpack_public_path__ + "static/sport/ruleboximg2.5f3c931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/ruleboximg2.png
// module id = tV15
// module chunks = 0